import React, { useState, useEffect, useRef } from "react";
import {
    Dialog,
    DialogContent,
    Typography,
    Box,
    Button,
    IconButton,
} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { motion } from "framer-motion";

export default function Otpmodal({
    open,
    onClose,
    handleVerifyOTP,
    handleGenerateOTP,
    timer,
    mobile,
    disabled,
    generatedOtp,
    verifySuccess,
    error
}) {
    const [otp, setOtp] = useState(["", "", "", ""]);
    const inputRefs = useRef([]);

    useEffect(() => {
        if (verifySuccess) {
            setOtp(["", "", "", ""]);
            inputRefs.current[0]?.focus();
        }
    }, [verifySuccess]);

    const handleChange = (value, index) => {
        if (!/^\d?$/.test(value)) return;

        const updated = [...otp];
        updated[index] = value;
        setOtp(updated);

        if (value && index < 3) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    borderRadius: 5,
                    width: 420,
                    p: 1,
                },
            }}
        >
            <DialogContent>

                <IconButton
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 12,
                        top: 12,
                    }}
                >
                    <CloseRoundedIcon />
                </IconButton>

                <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{
                        duration: .4,
                        type: "spring"
                    }}
                >
                    <CheckCircleRoundedIcon
                        sx={{
                            color: "#22C55E",
                            fontSize: 70,
                            display: "block",
                            mx: "auto",
                        }}
                    />
                </motion.div>

                <Typography
                    variant="h5"
                    align="center"
                    mt={2}
                    fontWeight={700}
                >
                    Verify OTP
                </Typography>

                <Typography
                    align="center"
                    color="text.secondary"
                    mt={1}
                >
                    OTP has been sent to your mobile number
                </Typography>

                <Typography
                    align="center"
                    fontWeight={600}
                    color="#1976d2"
                    mt={0.5}
                >
                    {mobile}
                </Typography>

                <Box
                    mt={4}
                    display="flex"
                    justifyContent="center"
                    gap={1.2}
                >
                    {otp.map((digit, index) => (
                        <motion.input
                            whileFocus={{
                                scale: 1.08,
                            }}
                            key={index}
                            ref={(el) => (inputRefs.current[index] = el)}
                            value={digit}
                            maxLength={1}
                            onChange={(e) =>
                                handleChange(e.target.value, index)
                            }
                            onKeyDown={(e) =>
                                handleKeyDown(e, index)
                            }
                            style={{
                                width: 52,
                                height: 58,
                                textAlign: "center",
                                fontSize: 24,
                                fontWeight: 700,
                                borderRadius: 12,
                                border: "2px solid #E5E7EB",
                                outline: "none",
                            }}
                        />
                    ))}
                </Box>
                {error && (
                    <Typography
                        variant="body2"
                        color="error"
                        sx={{ mt: 1, textAlign: "center" }}
                    >
                        {error}
                    </Typography>
                )}
                <Typography
                    align="center"
                    mt={3}
                    fontWeight={700}
                    color="#F13243"
                >
                    00:{timer.toString().padStart(2, "0")}
                </Typography>

                <Typography
                    align="center"
                    mt={1}
                    color="text.secondary"
                >
                    Didn't receive OTP?
                </Typography>

                <Typography
                    align="center"
                    fontWeight={600}
                    sx={{
                        color: timer === 0 ? "#1976d2" : "#BDBDBD",
                        cursor: timer === 0 ? "pointer" : "not-allowed",
                        pointerEvents: timer === 0 ? "auto" : "none", justifyContent: 'center', alignItems: 'center'
                    }}
                    onClick={() => handleGenerateOTP()}
                >
                    Resend OTP
                </Typography>

                <Box
                    mt={4}
                    display="flex"
                    gap={2}
                >
                    <Button
                        fullWidth
                        variant="outlined"
                        onClick={onClose}
                        sx={{
                            borderRadius: 3,
                            py: 1.3,
                        }}
                    >
                        Cancel
                    </Button>

                    <motion.div
                        whileHover={{ scale: 1.03 }}
                        whileTap={{ scale: .96 }}
                        style={{ width: "100%" }}
                    >
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={() => handleVerifyOTP(otp.join(""))}
                            sx={{
                                py: 1.3,
                                borderRadius: 3,
                                background:
                                    "linear-gradient(135deg,#DC1F30,#F04050)",
                                textTransform: "none",
                                fontWeight: 600,
                            }}
                        >
                            Verify OTP
                        </Button>
                    </motion.div>
                </Box>

            </DialogContent>
        </Dialog>
    );
}